import { defineComponent } from 'vue';
import { filterByArea, filterByTime } from '@/constant/areaguide';
import { debounce } from '~/plugins/helper';
import { generateSaveQuery } from '@/plugins/helper';
var tagsMaxHeight = 74;
export default defineComponent({
    props: {
        tags: {
            type: Array,
            default: function () { return []; }
        },
        areas: {
            type: Array,
            default: function () { return []; }
        },
        activeTagName: {
            type: Array,
            default: function () { return []; }
        }
    },
    setup: function () {
        return {
            filterByTime: filterByTime,
            filterByArea: filterByArea,
            generateSaveQuery: generateSaveQuery
        };
    },
    data: function () {
        var _a = this.$route.query, area = _a.area, tags = _a.tags;
        var tagDefault = tags ? decodeURIComponent(tags).split(',') : [];
        var tagSelected = tagDefault;
        var haflScreen = 0;
        return {
            areaSelected: area || '',
            tagSelected: tagSelected,
            tagHeight: 74,
            showAllTags: false,
            showShowmoreButton: false,
            haflScreen: haflScreen
        };
    },
    watch: {
        tags: function () {
            var _this = this;
            window.setTimeout(function () {
                _this.checkMoreButton();
            }, 500);
        }
    },
    mounted: function () {
        this.haflScreen = Math.ceil(window.innerHeight / 2);
        window.addEventListener('resize', debounce(this.checkMoreButton, 30));
    },
    methods: {
        checkMoreButton: function () {
            var _a;
            this.showShowmoreButton = ((_a = this.$refs.tagRef) === null || _a === void 0 ? void 0 : _a.clientHeight) > tagsMaxHeight;
        },
        handleFilterByArea: function (sortParameter, isDisabled) {
            if (isDisabled) {
                return;
            }
            var valueSolved = this.generateSaveQuery(sortParameter);
            this.areaSelected = valueSolved;
            var tags = this.$route.query.tags;
            if (valueSolved) {
                this.$router.push({ query: { tags: tags, area: valueSolved } });
            }
            else {
                this.$router.push({ query: { tags: tags } });
            }
            this.scrollToList();
        },
        handleFilterByTag: function (_a) {
            var checked = _a.checked, value = _a.value;
            var valueSolved = this.generateSaveQuery(value);
            if (checked) {
                this.tagSelected.push(valueSolved);
            }
            else {
                this.tagSelected = this.tagSelected.filter(function (item) { return item !== valueSolved; });
            }
            var area = this.$route.query.area;
            if (this.tagSelected.length === 0) {
                this.$router.push({ query: { area: area } });
            }
            else {
                this.$router.push({ query: { area: area, tags: this.tagSelected.join(',') } });
            }
            this.scrollToList();
        },
        handleShowAllTags: function () {
            this.showAllTags = !this.showAllTags;
        },
        scrollToList: function () {
            this.$scrollTo('#areaguideProgramList', {
                offset: -this.haflScreen
            });
            // To fix bug jump to top
            this.haflScreen += 1;
        },
        isActiveArea: function (item) {
            return this.areaSelected === this.generateSaveQuery(item.sortParameter) || this.areaSelected === item.areaName;
        },
        isDisabledArea: function (areaName) {
            return !this.activeTagName.includes(areaName);
        }
    }
});
